// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TagTeamIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M12.32 15.25c-4.43 0-5.4 1.73-5.4 3.35.1 1.3.97 2.06 2.16 2.06h6.49c1.3 0 2.16-.87 2.16-2.17 0-1.51-.97-3.24-5.4-3.24m-.01-1.41c1.73 0 3.03-1.3 3.03-3.03s-1.3-3.03-3.03-3.03S9.3 9.08 9.3 10.8c0 1.62 1.4 3.03 3.03 3.03" />
      <path
        d="M17.84 9.94q-.32 0-.65.33c-.1.21-.21.43-.21.65.1 1.19 0 2.27-.44 3.24-.1.22-.1.55.11.76.1.22.43.33.65.33h3.14c1.19 0 2.05-.98 2.05-2.28.11-2.05-1.4-3.03-4.65-3.03M6.15 8.54c1.41 0 2.6-1.2 2.6-2.6s-1.19-2.6-2.6-2.6c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6m12.02 0c1.4 0 2.6-1.2 2.6-2.6s-1.2-2.6-2.6-2.6-2.6 1.2-2.6 2.6 1.19 2.6 2.6 2.6m-10.5 5.52c-.43-1.09-.54-2.06-.43-3.25 0-.22 0-.43-.22-.65q-.16-.32-.65-.32c-3.25 0-4.87 1.08-4.87 3.03 0 1.3.97 2.27 2.16 2.27H6.8c.22 0 .54-.11.65-.33.33-.21.33-.43.22-.75"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default TagTeamIcon;
